import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginAndRegDialogComponent } from './components/login-and-reg-dialog/login-and-reg-dialog.component';
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { PlatformsLoginComponent } from './components/platforms-login/platforms-login.component';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from './services/auth.service';
import { HttpClientModule } from '@angular/common/http';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {TranslateModule} from '@ngx-translate/core';
import {NgxEchartsModule} from 'ngx-echarts';
import {RecaptchaModule} from 'ng-recaptcha';

@NgModule({
    declarations: [
        LoginAndRegDialogComponent,
        LoginComponent,
        RegistrationComponent,
        PlatformsLoginComponent,
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatTabsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        HttpClientModule,
        MatCheckboxModule,
        TranslateModule,
        RecaptchaModule,
        NgxEchartsModule.forRoot({
        echarts: () => import('echarts')
         })
    ],
    exports: [
        LoginAndRegDialogComponent
    ],
    providers: [
        AuthService
    ]
})
export class LoginModule { }
